import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export const securityRecommendation = createRemoteArrayResourceReducer(
  "SECURITY_RECOMMENDATION"
);
